
<template>
<div >
   <v-layout wrap>
       <v-flex>
           <v-img src="../../assets/Images/white.jpg" class="align-center" height="100vh">
    <v-layout wrap style="background-color:#F8F8F8" class="sland"  pa-3 pa-sm-5 pa-lg-0  >
    <v-flex xs6 pa-lg-16 align-self-start class="sland2">

        <v-layout wrap pt-lg-16 pt-sm-8 px-lg-16  >
            <v-flex xs12 text-left pb-8 >
             <v-btn color="#242B48" x-small dark class="ibmsemibold" style="text-transform:none">Seller Panel</v-btn>
            </v-flex>
            <v-flex xs12 text-left>
                <span style="font-size:40px;line-height:1em" class="ibmbold" color="#000000"> Scale Up your <br> business</span>
            </v-flex>
            <v-flex xs12 text-left pt-2>
         <span style="color:#7B7B7B" class="ibmsemibold"> Login as a seller on Agogo now</span>
            </v-flex>
            <v-flex xs12 text-left py-3>
             <v-btn color="#E31E24" dark rounded style="padding-left:30px;padding-right:30px;text-transform:none" @click="goTo" small>Login</v-btn>
            </v-flex>
             <v-flex xs12 text-left py-3>
             <v-btn color="#E31E24" dark rounded style="padding-left:30px;padding-right:30px;text-transform:none" @click="goTosignup" small>Signup</v-btn>
            </v-flex>
        </v-layout>
        
    </v-flex>
     <v-flex xs6 class="sland2" pt-6>
         <v-img height="400px" contain src="../../assets/Images/Group 40.svg">
         </v-img>
    </v-flex>
        
    </v-layout>
    <v-layout pt-8 px-lg-16>
        <v-flex xs12 px-lg-16>
             <v-card>
       <v-layout wrap  style="background-color:#121212">
           <v-flex xs6>
           <v-layout wrap pa-6>
           <v-flex xs12 text-left>
           <span style="color:white" class="sofiaPro">   Start selling today</span>
           </v-flex>
            <v-flex xs12 text-left>
           <span style="color:white;line-height: .05;" class="xsmall ibmsemibold" >   lorem ipsum is a simple dummt text of the printing <br> and setting industry </span>
           </v-flex>
           </v-layout>
           </v-flex>
           <v-flex xs6 align-self-end>
               <v-img class="mx-auto" height="100px" contain src="../../assets/Images/iphone.png">
         </v-img>
           </v-flex>
       </v-layout>
       </v-card>

        </v-flex>
    </v-layout>
    </v-img>
     </v-flex>
   </v-layout>
    
</div>
</template>
<script>
export default {
    data()
    {
        return{


        }
    },
    methods:
    {
        goTo()
        {
         this.$emit("stepper", {
              winStep: 0,
              type:'signin'
            });
            
        },
        goTosignup()
        {
         this.$emit("stepper", {
              winStep: 0,
              type:'signup'

            });
            
        }
    }
}
</script>
<style >
 .sland
 {
 -webkit-transform: skewy(-3deg);
  transform: skewy(-3deg);
 }
 .sland2
 {
 -webkit-transform: skewy(+3deg);
  transform: skewy(+3deg);
 }
 .sland3
 {
 -webkit-transform: skewy(-2deg);
  transform: skewy(-2deg);
 }
</style>